import { Button, Card, Container, Group, PasswordInput, Stack, Text, TextInput, ThemeIcon, Title } from '@mantine/core'
import { modals } from '@mantine/modals'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LuZap } from 'react-icons/lu'

export const Route = createFileRoute('/dashboard/utilities')({
  component: UtilitiesPage,
})

function UtilitiesPage() {
  const { t } = useTranslation()

  const showComingSoon = () =>
    modals.open({
      title: t('page.utilities.modal_title'),
      size: 'md',
      children: (
        <Stack gap="sm">
          <Text size="sm">{t('page.utilities.integration_body1')}</Text>
          <Text size="sm" c="dimmed">
            {t('page.utilities.integration_body2')}
          </Text>
          <Text size="sm" c="dimmed">
            {t('page.utilities.integration_body3')}
          </Text>
        </Stack>
      ),
    })

  return (
    <Container size="md" py="md">
      <Stack gap="lg">
        <Group gap="sm" align="center">
          <ThemeIcon variant="light" color="laut" size="lg" radius="md">
            <LuZap size={18} />
          </ThemeIcon>
          <div>
            <Title order={2} ff="var(--font-display)" fw={600}>
              {t('page.utilities.title')}
            </Title>
            <Text size="xs" c="dimmed">
              {t('page.utilities.subtitle')}
            </Text>
          </div>
        </Group>

        {/* Coming-soon notice */}
        <Card
          radius="md"
          padding="lg"
          style={{ background: 'light-dark(var(--mantine-color-laut-0), rgba(14,124,123,0.1))' }}
        >
          <Stack gap="xs" align="center" ta="center">
            <Text size="xl">⚡</Text>
            <Text fw={700} size="md">
              {t('page.utilities.coming_soon_title')}
            </Text>
            <Text size="sm" c="dimmed" maw={400}>
              {t('page.utilities.coming_soon_body')}
            </Text>
          </Stack>
        </Card>

        <Card padding={0} radius="md" maw={480} mx="auto" style={{ overflow: 'hidden' }}>
          <Stack gap="lg" p="xl" align="center">
            <BenoaLogo />
            <Stack gap={2} align="center">
              <Title order={3} ff="var(--font-display)" fw={600}>
                {t('page.utilities.login_title')}
              </Title>
              <Text size="sm" c="dimmed" ta="center">
                {t('page.utilities.login_subtitle')}
              </Text>
            </Stack>
            <Stack gap="md" w="100%">
              <TextInput
                label={t('page.utilities.email_label')}
                placeholder={t('page.utilities.email_placeholder')}
                type="email"
                disabled
              />
              <PasswordInput label={t('page.utilities.password_label')} placeholder="••••••••" disabled />
              <Group justify="flex-end">
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }} onClick={showComingSoon}>
                  {t('page.utilities.forgot_password')}
                </Text>
              </Group>
              <Button fullWidth size="md" color="gray" onClick={showComingSoon}>
                {t('page.utilities.btn_login')}
              </Button>
            </Stack>
          </Stack>
        </Card>

        <Text c="dimmed" size="xs" ta="center">
          {t('page.utilities.footer_credit')}
        </Text>
      </Stack>
    </Container>
  )
}

function BenoaLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="40"
      viewBox="0 0 240 48"
      role="img"
      aria-label="Benoa Marina Bali"
    >
      <title>Benoa Marina Bali</title>
      <g fill="none" stroke="#1C7ED6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 30 L24 14 L32 30" />
        <path d="M20 22 L28 22" />
        <path d="M14 34 Q24 40 34 34" strokeWidth="1.5" opacity="0.6" />
        <path d="M16 38 Q24 42 32 38" strokeWidth="1" opacity="0.4" />
      </g>
      <text
        x="50"
        y="22"
        fill="#1C7ED6"
        fontFamily="'Plus Jakarta Sans', sans-serif"
        fontSize="13"
        fontWeight="700"
        letterSpacing="1.5"
      >
        BENOA MARINA
      </text>
      <text
        x="50"
        y="38"
        fill="#74B9FF"
        fontFamily="'Plus Jakarta Sans', sans-serif"
        fontSize="11"
        fontWeight="500"
        letterSpacing="2"
      >
        B A L I
      </text>
    </svg>
  )
}
